"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=VizQLDataServiceInterfaces.js.map